import { get, post, put } from '../request';
import { APP_CONFIG } from '../../config';
import type { BillcheckDetails, DocumentUrlsResponse, SubmitBillCheckReq } from '../../@types/billCheckV3';
import { ApiEndpoints } from '../apiEndpoints.constant';
import type { Documents, StartBillCheckResponse } from '@/@types/billCheckV3';

export const startBillCheckProcess = async (): Promise<StartBillCheckResponse | null> => {
  return await post(`${APP_CONFIG.baseApiUrl}${ApiEndpoints.startBillCheck}`, undefined, 'XSRF-TOKEN');
};

export const getBillCheckDetails = async (billCheckFlowId: string | undefined): Promise<BillcheckDetails> => {
  return await get(`${APP_CONFIG.baseApiUrl}${ApiEndpoints.billCheckDetails}${billCheckFlowId}`, 'XSRF-TOKEN');
};

export const updateBillCheckDetails = async (billCheckFlowId: string, payload: BillcheckDetails) => {
  return await put(`${APP_CONFIG.baseApiUrl}${ApiEndpoints.billCheckDetails}${billCheckFlowId}`, payload, 'XSRF-TOKEN');
};

export const submitBillCheckDetails = async (billCheckFlowId: string, payload: SubmitBillCheckReq) => {
  return await post(`${APP_CONFIG.baseApiUrl}${ApiEndpoints.submitBillCheck}${billCheckFlowId}`, payload, 'XSRF-TOKEN');
};

export const generateDocumentUploadUrl = async (
  billCheckFlowId: string,
  payload: Documents,
): Promise<DocumentUrlsResponse | null> => {
  return await post(
    `${APP_CONFIG.baseApiUrl}${ApiEndpoints.generateSignedDocumentUploadUrl}${billCheckFlowId}`,
    payload,
    'XSRF-TOKEN',
  );
};

export const uploadBillCheckDocuments = ({
  signedDocumentUploadUrls,
  selectedRentalContractFiles,
  selectedOperationalStatementFiles,
}: {
  signedDocumentUploadUrls: DocumentUrlsResponse;
  selectedRentalContractFiles: File[];
  selectedOperationalStatementFiles: File[];
}) => {
  const rentalContractUploadPromises = signedDocumentUploadUrls.rentalContractUploadUrls.map((rentalContract, index) =>
    fetch(rentalContract.signedUploadUrl, {
      method: 'PUT',
      body: selectedRentalContractFiles[index],
    }),
  );

  const operationalStatementUploadPromises = signedDocumentUploadUrls.operationalStatementUploadUrls.map(
    (operationalStatement, index) =>
      fetch(operationalStatement.signedUploadUrl, {
        method: 'PUT',
        body: selectedOperationalStatementFiles[index],
      }),
  );
  return [...rentalContractUploadPromises, ...operationalStatementUploadPromises];
};
